import React, { useEffect, useState } from "react";
import FolderTreeComponent from "../../component/tree-folder/TreeFolderComponent";
import { Select } from "antd";
import classDdl from "../../models/control/dropdownlist";
import { handleCatchError, renderOption } from "../../constants/utils";
import { findParent, transformData } from "../../utils/treeFolder";
import { filterData, removeTopLayer } from "./equipmentFolderTree";
import SelectWithLabel from "../../component/FormInput/SelectWithLabel";
import { InstallLocationApi } from "../../api/backend/installLocation";

const ModalSelectLocationInstall = ({
  onSelect,
  initFilter,
  listSelects = [],
  listExpands = [],
  setListSelects = () =>{},
  setListExpands = ()=>{},
}) => {
  const [filterLocation, setFilterLocation] = useState(new classDdl());
  const [data, setData] = useState([]);

  useEffect(() => {
    if (initFilter) {
      setFilterLocation(initFilter);
      getTreeLocation(initFilter.value);
    }
  }, [initFilter]);
 
  const getTreeLocation = async (facilityCode) => {
    try {
      const res = await InstallLocationApi.getTreeLocationByFacilityCode({
        facilityCode,
      });
      setData(res.data);
    } catch (error) {
      handleCatchError(error);
    }
  };

  
  const treeData = transformData(data, "", listExpands);

  const handleSelect = (_, info) => {
    const node = info.node || {};
    const listParent = findParent(treeData, node.key, []);
    let name = node.name;
    if (listParent && Array.isArray(listParent) && listParent.length) {
      name = listParent
        .map((i) => i.name)
        .concat(node.name)
        .join(" / ");
    }
    onSelect({
      value: node.id,
      label: name,
      order: node.order,
    });
  };
  return (
    <div>
      <div className="mt mb10">
        <SelectWithLabel
          
          disabled={true}
          options={filterLocation.options}
          label="施設"
          value={filterLocation.value}
          onChange={ (e) => {
            setFilterLocation({ ...filterLocation, value: e })
            getTreeLocation(e)
            setListExpands([]);
            setListSelects([])
          }}
          className="w100 mb10"
        />
      </div>
      <FolderTreeComponent
        onSelect={handleSelect}
        data={treeData}
        currentKey={filterLocation.value}
        listSelects={listSelects}
        listExpands={listExpands}
        setListSelects={setListSelects}
        setListExpands={setListExpands}
      />
    </div>
  );
};

export default ModalSelectLocationInstall;
